import { Button, Select } from "antd";
import { useHistory } from "react-router-dom";
import { Locale } from "../../utils";

const i18n = Locale.getInstance();
const { Option } = Select;

const CustomPageListHeader = ({
  pageType,
  setPageType,
  language,
  setLanguage,
  status,
  setStatus,
}) => {
  const router = useHistory();

  return (
    <div className="header">
      <div className="actions">
        <Button
          onClick={() => {
            router.push({
              pathname: `/main/custom-pages/create`,
            });
          }}
          type="primary"
        >
          {i18n.t("customPage.create")}
        </Button>
      </div>
      <div className="search">
        <Select
          style={{ width: 150, marginRight: 8 }}
          placeholder={i18n.t("customPage.pageType")}
          allowClear
          value={pageType}
          onChange={(value) => setPageType(value)}
        >
          <Option value="home">{i18n.t("customPage.pageTypeHome")}</Option>
          <Option value="user">{i18n.t("customPage.pageTypeUser")}</Option>
          <Option value="video-list">{i18n.t("customPage.pageTypeVideoList")}</Option>
        </Select>
        <Select
          style={{ width: 150, marginRight: 8 }}
          placeholder={i18n.t("customPage.language")}
          allowClear
          value={language}
          onChange={(value) => setLanguage(value)}
        >
          <Option value="ug">{i18n.t("customPage.languageUyghur")}</Option>
          <Option value="zh">{i18n.t("customPage.languageChinese")}</Option>
        </Select>
        <Select
          style={{ width: 150, marginRight: 8 }}
          placeholder={i18n.t("common.statusLabel")}
          allowClear
          value={status}
          onChange={(value) => setStatus(value)}
        >
          <Option value="draft">{i18n.t("customPage.statusDraft")}</Option>
          <Option value="published">{i18n.t("customPage.statusPublished")}</Option>
        </Select>
      </div>
    </div>
  );
};

export default CustomPageListHeader;


